import { createContext, useContext, useEffect, useState } from "react";
import { api, API } from "@/lib/api";

const MetaCtx = createContext(null);

function injectFonts(fonts) {
  if (document.getElementById("hs-stamp-fonts")) return;
  const css = fonts
    .flatMap((f) => {
      const v = [["400", "normal"]];
      if (f.bold) v.push(["700", "normal"]);
      if (f.italic) v.push(["400", "italic"]);
      if (f.bold_italic) v.push(["700", "italic"]);
      return v.map(
        ([w, s]) =>
          `@font-face{font-family:"hs-${f.id}";src:url("${API}/fonts/file/${f.id}/${w}-${s}") format("truetype");font-weight:${w};font-style:${s};font-display:block;}`
      );
    })
    .join("\n");
  const el = document.createElement("style");
  el.id = "hs-stamp-fonts";
  el.textContent = css;
  document.head.appendChild(el);
  fonts.forEach((f) => document.fonts.load(`16px "hs-${f.id}"`).catch(() => {}));
}

export function MetaProvider({ children }) {
  const [meta, setMeta] = useState(null);
  const load = () =>
    api.get("/meta").then((r) => {
      injectFonts(r.data.fonts);
      setMeta(r.data);
    });
  useEffect(() => {
    load();
  }, []);
  return <MetaCtx.Provider value={meta ? { ...meta, reload: load } : null}>{children}</MetaCtx.Provider>;
}

export const useMeta = () => useContext(MetaCtx);
export const inkHex = (meta, id) => meta?.inks.find((i) => i.id === id)?.hex || "#111827";

export function useFontsTick() {
  const [t, setT] = useState(0);
  useEffect(() => {
    const f = () => setT((x) => x + 1);
    document.fonts.addEventListener("loadingdone", f);
    document.fonts.ready.then(f);
    return () => document.fonts.removeEventListener("loadingdone", f);
  }, []);
  return t;
}
